import { useEffect } from 'react';
import { DashboardFilter } from 'generated/maya.types';
import useCountTacticsQuery from 'modules/maya/graphql/queries/countTactics';

const useCountTacticsWidget = (filters?: DashboardFilter) => {
  const { countTacticsQuery, tacticsData, loading, error } = useCountTacticsQuery();

  useEffect(() => {
    if (filters) {
      countTacticsQuery({ variables: { filters } });
    }
  }, [filters, countTacticsQuery]);

  return {
    value: tacticsData,
    loading,
    error,
  };
};

export default useCountTacticsWidget;
